import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/facebook.webp'
import _imports_1 from '@/assets/images/icons/instagram.webp'


const _withScopeId = n => (_pushScopeId("data-v-be11d812"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "social_media_sec overlay_bg",
  id: "kumhoContactUs"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container\" data-v-be11d812><h2 class=\"title text-center white border_none\" data-v-be11d812> FOLLOW US ON SOCIAL MEDIA </h2><ul class=\"socail_list\" data-v-be11d812><li data-v-be11d812><a href=\"https://www.facebook.com/profile.php?id=61553083419279\" target=\"_blank\" data-v-be11d812><img src=\"" + _imports_0 + "\" alt=\"Facebook\" data-v-be11d812></a></li><li data-v-be11d812><a href=\"https://www.instagram.com/kumho_tyressa/\" target=\"_blank\" data-v-be11d812><img src=\"" + _imports_1 + "\" alt=\"Instagram\" data-v-be11d812></a></li></ul></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}